module.exports = __webpack_public_path__ + "img/adress_icon.66c961cd.png";